"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SliderV = require("./SliderV2.styled");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SliderV2 = function SliderV2(_ref) {
  var seek = _ref.seek,
    onSeek = _ref.onSeek,
    onChange = _ref.onChange,
    duration = _ref.duration,
    readOnly = _ref.readOnly,
    isLight = _ref.isLight;
  var StyledTrack = isLight ? _SliderV.LightStyledTrack : _SliderV.DarkStyledTrack;
  var StyledThumb = isLight ? _SliderV.LightStyledThumb : _SliderV.DarkStyledThumb;
  var Thumb = function Thumb(props) {
    return _react["default"].createElement(StyledThumb, props);
  };
  var Track = function Track(props, state) {
    return _react["default"].createElement(StyledTrack, (0, _extends2["default"])({}, props, {
      index: state.index
    }));
  };
  var ReadOnlyAwareThumb = function ReadOnlyAwareThumb(props, state) {
    return Thumb(_objectSpread(_objectSpread({}, props), {}, {
      readOnly: readOnly
    }), state);
  };
  var TransparencyAwareTrack = function TransparencyAwareTrack(props, state) {
    return Track(_objectSpread({}, props), state);
  };
  var getSeek = function getSeek(value) {
    return value / 100 * duration;
  };
  var handleSeek = function handleSeek(value) {
    onSeek(getSeek(value));
  };
  var handleChange = function handleChange(value) {
    onChange(getSeek(value));
  };
  var sliderValue = seek / duration * 100;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_SliderV.StyledSlider, {
    renderThumb: ReadOnlyAwareThumb,
    renderTrack: TransparencyAwareTrack,
    readOnly: readOnly,
    disabled: readOnly,
    onChange: handleChange,
    onSliderClick: handleSeek,
    onAfterChange: handleSeek,
    value: sliderValue,
    defaultValue: sliderValue
  }));
};
var _default = exports["default"] = SliderV2;
SliderV2.propTypes = {
  seek: _propTypes["default"].number,
  onSeek: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  duration: _propTypes["default"].number,
  readOnly: _propTypes["default"].bool,
  isLight: _propTypes["default"].bool
};